module.exports = __webpack_public_path__ + "img/cisco-2.f2d7250c.webp";